import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AdminLogin from './pages/auth/admin_login';
import { setCompanyFromLocalStorage, setUserFromLocalStorage } from './slices/admin/authSlice';
import AdminProtectedRoutes from './utils/adminProtectedRoutes';
import AdminRoutes from './routes/admin';
import CompanyLogin from './pages/auth/company_login';
import CompanyProtectedRoutes from './utils/companyProtectedRoute';
import CompanyRoutes from './routes/company';
import BarcodeScanner from './pages/company/scanner';
import CamScannerPage from './pages/company/camscanner';

function App() {
  const { admin, company } = useSelector((state) => state.adminauth);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const userData = localStorage.getItem('admin');
    const companyData = localStorage.getItem('company');
    if (userData) {
      dispatch(setUserFromLocalStorage({ admin: JSON.parse(userData) }));
    } else if (companyData) {
      dispatch(setCompanyFromLocalStorage({ company: JSON.parse(companyData) }));
    }
    setLoading(false);
  }, [dispatch]);

  useEffect(() => {
    const html = document.documentElement;
    html.lang = "en";

    html.setAttribute("data-color", "lunargreen");
    html.setAttribute("data-theme", "light");
    html.setAttribute("data-sidebar", "light");
    html.setAttribute("data-topbar", "white");
    html.setAttribute("data-width", "fluid");
    html.setAttribute("data-layout", "default");
    html.setAttribute("style", "--sidebar-rgb: 216, 24, 10;");
    // html.setAttribute("data-layout", "vertical");
    // html.setAttribute("data-topbar", "light");
    // html.setAttribute("data-sidebar", "dark");
    // html.setAttribute("data-sidebar-size", "lg");
    // html.setAttribute("data-sidebar-image", "none");
    // html.setAttribute("data-preloader", "disable");
    // html.setAttribute("data-theme", "default");
    // html.setAttribute("data-theme-colors", "default");
    // html.setAttribute("data-bs-theme", "light");
    // html.setAttribute("data-layout-width", "fluid");
    // html.setAttribute("data-layout-position", "fixed");
    // html.setAttribute("data-layout-style", "default");
    // html.setAttribute("data-body-image", "none");
    // html.setAttribute("data-sidebar-visibility", "show");
  }, []);

  if (loading) {
    return (
      <div id="global-loader">
        <div className="whirly-loader"> </div>
      </div>
    );
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={company && !admin ? <Navigate to="/dashboard" replace /> : admin ? <Navigate to="/admin/dashboard" replace /> : <CompanyLogin />}
        />
        <Route
          path="/scanner"
          element={<BarcodeScanner />} />

        <Route
          path="/admin/login"
          element={admin && !company ? <Navigate to="/admin/dashboard" replace /> : company ? <Navigate to="/company/dashboard" replace /> : <AdminLogin />}
        />
        <Route element={<AdminProtectedRoutes />}>
          <Route path="/admin/*" element={<AdminRoutes />} /> {/* Correct path for AdminRoutes */}
        </Route>
        <Route element={<CompanyProtectedRoutes />}>
          <Route path="/*" element={<CompanyRoutes />} /> {/* Correct path for AdminRoutes */}
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
